import React, { useEffect, useState, useMemo } from 'react';
import { SimpleLoading, InputHLPure, GridSelectionHLPure, PanelBarGLPure, ButtonHLPure, DialogSystemGLPure } from '../../pures';
import { Grid, Container } from "@material-ui/core";
import { useTranslation } from 'react-i18next';
import PdfReader from "../../pures/adobePfdReader/PdfReader";
import "./contractors-catalog-documents.view.css";

const ContractorsCatalogViewDocuments = (props) => {
    let { t } = useTranslation();

    let {
        contractorGridSelected,
        isLoadingView,
        titleColumnName,
        documents,
        backGridView,
        getContractorClientDocument,
        toggleErrorRequesting,
        toggleLoadingRequesting,
        toggleCompletedRequesting,
        showCompletedRequesting,
        showErrorRequesting,
        showLoadingRequesting,
        messageError,
        beforePage,
        sendOtherPage
    } = props
    
    const headerColumnOneItem1 = (props) => {
        return <span className="contractorsCatalogViewDocuments-header-cell-one">{props.title}</span>;
    };

    const cellColumnOne = (props) => {
        return (
            <td className='contractorsCatalogViewDocuments-cell-one'>
                <div className="contractorsCatalogViewDocuments-labels-column1-labels-column1">
                    <p className='contractorsCatalogViewDocuments-title-column1'>
                        {props.dataItem.name}
                    </p>
                    <p className='contractorsCatalogViewDocuments-subtitle-column1'>
                        {props.dataItem.uploaded}
                    </p>
                </div>
            </td>
        );
    };

    const [companyInput, setCompanyInput] = useState('')
    const [documentsGrid, setDataGridDocumentsGrid] = useState([])
    const [documentSelected, setDocumentSelected] = useState({})
    const [urlPdf, setUrlPdf] = useState('')

    const pdf = useMemo(() => (<PdfReader className="pdfReader" url={urlPdf} awsURL showDownloadPDF={true} />), [urlPdf]);
    let nameInput = `${t("contractorsCatalogViewDocuments.name.title")} ${titleColumnName}`
    let rfcInput = `${t("contractorsCatalogViewDocuments.rfc.title")} ${titleColumnName}`

    useEffect(() =>{
        toggleLoadingRequesting(true)
        if(!contractorGridSelected || !contractorGridSelected.company || contractorGridSelected.company.length === 0) return
        getContractorClientDocument(contractorGridSelected.id)
        let name =''
        for (let index = 0; index < contractorGridSelected.company.length; index++) {
            if(index === 0){
                name =  contractorGridSelected.company[index].companyName
            }else{
                name = name + `, ${contractorGridSelected.company[index].companyName}`
            }          
        }
        setCompanyInput(name)
    },[contractorGridSelected])

    useEffect(() => {
        if(!documents || documents.length === 0)return
        setDataGridDocumentsGrid(documents)
        setUrlPdf(documents[0].path)
    }, [documents])

    const onHandleWatchDoc = (documento) => {
        setUrlPdf(documento.path)
    }

    const onHandleBack = () => {
        if(beforePage === t("contractorsCatalogView-btn-details")){
            sendOtherPage(t("contractorsCatalogView-btn-details"))
        }else{
            backGridView()
        }
    }
    
    return(
        <div className='contractorsCatalogViewDocuments-wrapper'>
            {
                isLoadingView ? (
                    <SimpleLoading />
                ) : (
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        lg={12}
                        className='contractorsCatalogViewDocuments-body'
                    >
                        <div className='contractorsCatalogViewDocuments-container-data'>
                            <InputHLPure
                                labelInput={nameInput}
                                typeInput={"text"}
                                valueInput={contractorGridSelected.name}
                                inputActive={true}
                                disabled={true}
                            />
                            <InputHLPure
                                labelInput={rfcInput}
                                typeInput={"text"}
                                valueInput={contractorGridSelected.rfc}
                                inputActive={true}
                                disabled={true}
                            />                            
                            <InputHLPure
                                labelInput={t("contractorsCatalogViewDocuments.company.ttile")}
                                typeInput={"text"}
                                valueInput={companyInput}
                                inputActive={true}
                                disabled={true}
                            /> 
                        </div>
                        <div className='contractorsCatalogViewDocuments-container-docs-pdf'>
                            <div className='contractorsCatalogViewDocuments-panel'>
                                <PanelBarGLPure
                                    expandedPanel={true}
                                    titlePanel={t("contractorsCatalogViewDocuments.panel.documents")}
                                >
                                    <Grid item className={(documents.length > 7) ? "contractorsCatalogViewDocuments-grid-documents-scroll" : "contractorsCatalogViewDocuments-grid-documents"}>
                                        <GridSelectionHLPure
                                            styleGeneral={true}
                                            styleGeneralClass={"contractorsCatalogViewDocuments-general-grid"}
                                            pageable={false}
                                            skip={0}
                                            take={documentsGrid.length}
                                            dataGrid={documentsGrid}
                                            filter={true}
                                            onSelectedItem={setDocumentSelected}
                                            setNameComponentUser={() => console.log('')}
                                            setShowDetails={() => console.log('')}
                                            headerColumnOne={headerColumnOneItem1}
                                            cellColumnOne={cellColumnOne}
                                            columnFive={true}
                                            titleRow1={t("contractorsCatalogViewDocuments.documents.title.1")}
                                            titleRow5={t("contractorsCatalogViewDocuments.actions.title.5")}
                                            iconOneActive={true}
                                            labelOneActions={t("contractorsCatalogViewDocuments.watch.doc.btn")}
                                            activeDialog1={true}
                                            btnOpenDialog1={(dataItem) => onHandleWatchDoc(dataItem)}
                                            styleGrid={{ maxHeight: '400px' }}
                                            mobileFunction={true}
                                        />
                                    </Grid>
                                </PanelBarGLPure>
                            </div>
                            <Grid
                                item
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                className="contractorsCatalogViewDocuments-pdf"
                            >
                                {pdf}
                            </Grid>
                        </div>
                        <div className='contractorsCatalogViewDocuments-container-btns'>
                            <ButtonHLPure
                                primary={false}
                                nameBtn={t("button.return")}
                                onClickBtn={onHandleBack}
                            />
                        </div>
                        {
                            showCompletedRequesting || showLoadingRequesting || showErrorRequesting ?
                                <DialogSystemGLPure
                                    showLoadingRequesting={showLoadingRequesting}
                                    showCompletedRequesting={showCompletedRequesting}
                                    showErrorRequesting={showErrorRequesting}
                                    toggleLoadingRequesting={toggleLoadingRequesting}
                                    toggleCompletedRequesting={toggleCompletedRequesting}
                                    toggleErrorRequesting={toggleErrorRequesting}
                                    message={messageError}
                                />
                                : null
                        }
                    </Grid>
                )
            }
        </div>
    )
}

export default ContractorsCatalogViewDocuments;